"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PanelLegendVisualizations = require("./PanelLegendVisualizations.css");

var _PanelLegendVisualizations2 = _interopRequireDefault(_PanelLegendVisualizations);

var _constants = require("../../utils/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//     

var PanelLegendVisualizations = function (_Component) {
	_inherits(PanelLegendVisualizations, _Component);

	function PanelLegendVisualizations() {
		_classCallCheck(this, PanelLegendVisualizations);

		var _this = _possibleConstructorReturn(this, (PanelLegendVisualizations.__proto__ || Object.getPrototypeOf(PanelLegendVisualizations)).call(this));

		_this.state = {};

		return _this;
	}

	_createClass(PanelLegendVisualizations, [{
		key: "getUpdatedRangs",
		value: function getUpdatedRangs(index, labelrangs) {

			// console.info('getUpdatedRangs',index);
			// console.info('getUpdatedRangsrangs',labelrangs);

			if (this.props.stateLabelRangs && this.props.stateLabelRangs.length) {

				//console.info("rr3", this.props.stateLabelRangs.length);
				if (this.props.stateLabelRangs.length == 32) {
					var rr = this.props.stateLabelRangs[index];

					if (rr == "-18") {
						rr = "-18<";
					}
					if (rr == "50") {
						rr = " >42";
					}

					return rr;
				} else {

					//console.info("rr0", this.props.stateLabelRangs[index]);
					return this.props.stateLabelRangs[index];
				}
			} else {
				//console.info("rr2", labelrangs[index]);
				return labelrangs[index];
			}
		}
	}, {
		key: "renderLegend",
		value: function renderLegend(visualizations) {
			var _this2 = this;

			if (this.props.width >= _constants.MAX_WIDTH_SCREEN_SIZE_LEGEND) {

				var itemH = [];

				visualizations.forEach(function (visualitzacio, indexV) {

					if (visualitzacio.isVisible) {
						var colors = visualitzacio.colorrangs.colorscale;
						var _pixel = parseInt(320 / colors.length);
						var _w = _pixel > 30 ? 25 : _pixel;
						var _h = _pixel > 30 ? 10 : 12;

						colors.map(function (color, indexC) {
							return itemH.push(_react2.default.createElement(
								"div",
								{ key: "" + indexV + indexC, style: { "width": _w + "px" }, className: _PanelLegendVisualizations2.default.legendRow },
								_react2.default.createElement(
									"div",
									{ className: _PanelLegendVisualizations2.default.legendFont },
									_this2.getUpdatedRangs(indexC, visualitzacio.labelrangs)
								),
								_react2.default.createElement("div", { className: _PanelLegendVisualizations2.default.legendColor, style: { backgroundColor: color, height: _h + "px" } })
							));
						});
					}
				});

				return itemH;
			}
		}
	}, {
		key: "render",
		value: function render() {

			return _react2.default.createElement(
				"div",
				{ className: _PanelLegendVisualizations2.default.panelLegend, id: "panelLegend" },
				this.renderLegend(this.props.thematicoptions)
			);
		}
	}]);

	return PanelLegendVisualizations;
}(_react.Component);

exports.default = PanelLegendVisualizations;


PanelLegendVisualizations.propTypes = {

	layoutOptions: _propTypes2.default.object,
	thematicoptions: _propTypes2.default.array,
	stateLabelRangs: _propTypes2.default.array,
	width: _propTypes2.default.number
};
